/* ============================================================
   BrewClick — store script
   Upload to Shopify: Online Store > Themes > Edit code > Assets
   Then add to theme.liquid before </head>:
   <script src="{{ 'brewclick.js' | asset_url }}" defer></script>

   Pricing model
   -------------
   One unit price comes from the selected colour variant
   (data-price-cents). Each bundle tier is a QUANTITY of that same
   variant (data-qty) with an optional percentage off (data-off),
   so the tiers work with an AutoDS-synced product that has no
   "bundle" option of its own.

   tier price   = unit × qty × (100 − off) / 100
   crossed out  = (unit compare-at or unit) × qty
   button total = tier price + the ticked bumps in that tier

   Works on the static preview too; every block is guarded.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    if (window.BrewClick && window.BrewClick.moneyFormat) {
      return window.BrewClick.moneyFormat.replace(
        /\{\{\s*amount\s*\}\}/,
        (cents / 100).toFixed(2)
      );
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---------- 1. seamless marquees ---------------------------------- */
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.dataset.bcDone) return;
      track.dataset.bcDone = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });

    /* ---------- 2. product gallery ------------------------------------ */
    var main = document.getElementById('bcMain');
    var thumbs = document.getElementById('bcThumbs');
    if (main && thumbs) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.bc-thumb');
        if (!btn) return;
        e.preventDefault();
        main.src = btn.dataset.src;
        thumbs.querySelectorAll('.bc-thumb').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        btn.setAttribute('aria-current', 'true');
      });
    }

    /* ---------- 3. bundle tiers, per-unit colours and bumps ------------

       Each tier holds one <select> per unit, so "Buy 3" can be two White and
       one Black. Prices come from the selected <option> (data-price-cents), so
       colours may be priced differently without any extra work.

         tier price   = sum of picked unit prices x (100 - off) / 100
         crossed out  = sum of picked compare-at prices
         button total = tier price + the ticked bumps in that tier
    -------------------------------------------------------------------- */
    var tiersWrap = document.querySelector('.bc-tiers');
    if (!tiersWrap) return;

    var priceEl = document.getElementById('bcPrice');
    var wasEl = document.getElementById('bcWas');
    var offEl = document.getElementById('bcOff');
    var atcEl = document.getElementById('bcAtcPrice');
    var stickyEl = document.getElementById('bcStickyPrice');
    var idInput = document.getElementById('bcVariantId');
    var qtyInput = document.getElementById('bcQuantity');
    var bundles = document.querySelectorAll('input[name="bc-bundle"]');
    var addons = document.querySelectorAll('.bc-addon input');

    function selected(nodes) {
      for (var i = 0; i < nodes.length; i++) if (nodes[i].checked) return nodes[i];
      return null;
    }

    function setText(el, txt) { if (el && txt != null) el.textContent = txt; }

    function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }

    function num(v, fallback) {
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function tierOf(radio) {
      return radio && radio.closest ? radio.closest('.bc-tier') : null;
    }

    /* the one <select> per unit inside a tier */
    function picksIn(tier) {
      if (!tier) return [];
      return [].slice.call(tier.querySelectorAll('select[data-pick]'));
    }

    function chosen(select) {
      return select.options[select.selectedIndex] || null;
    }

    function unitCents(select) {
      var o = chosen(select);
      return o ? num(o.dataset.priceCents, 0) : 0;
    }

    function unitCompareCents(select) {
      var o = chosen(select);
      if (!o) return 0;
      return num(o.dataset.compareCents, 0) || num(o.dataset.priceCents, 0);
    }

    function sum(list, fn) {
      return list.reduce(function (t, x) { return t + fn(x); }, 0);
    }

    function tierQty(radio) {
      var picks = picksIn(tierOf(radio));
      return picks.length || Math.max(1, num(radio.dataset.qty, 1));
    }

    /* Shopify discounts each UNIT and floors that unit's discount amount, then
       multiplies by the quantity. Mirror it exactly or the page and the
       checkout disagree by a cent or two. */
    function discountedUnit(cents, off) {
      if (!off) return cents;
      return cents - Math.floor(cents * off / 100);
    }

    function tierCents(radio) {
      var picks = picksIn(tierOf(radio));
      var off = num(radio.dataset.off, 0);
      if (picks.length) {
        return sum(picks, function (s) { return discountedUnit(unitCents(s), off); });
      }
      var unit = num(tiersWrap.dataset.unitCents, 0);
      return discountedUnit(unit, off) * Math.max(1, num(radio.dataset.qty, 1));
    }

    function tierCompareCents(radio) {
      var picks = picksIn(tierOf(radio));
      if (picks.length) return Math.round(sum(picks, unitCompareCents));
      var per = num(tiersWrap.dataset.unitCompareCents, 0) || num(tiersWrap.dataset.unitCents, 0);
      return Math.round(per * Math.max(1, num(radio.dataset.qty, 1)));
    }

    /* only the selected tier's bumps count */
    function checkedAddons() {
      var tier = tierOf(selected(bundles));
      if (!tier) return [];
      return [].slice.call(tier.querySelectorAll('.bc-addon input:checked'));
    }

    function addonCents() {
      return checkedAddons().reduce(function (t, a) {
        return t + num(a.dataset.priceCents, 0);
      }, 0);
    }

    /* one cart line per distinct colour, plus the ticked bumps */
    function cartItems() {
      var radio = selected(bundles);
      var picks = picksIn(tierOf(radio));
      var counts = {};
      var order = [];

      picks.forEach(function (s) {
        if (!s.value) return;
        if (!counts[s.value]) { counts[s.value] = 0; order.push(s.value); }
        counts[s.value] += 1;
      });

      if (!order.length && idInput && idInput.value) {
        counts[idInput.value] = Math.max(1, num(radio && radio.dataset.qty, 1));
        order.push(idInput.value);
      }

      var items = order.map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });

      checkedAddons().forEach(function (a) {
        if (!a.dataset.variantId) return;
        items.push({
          id: Number(a.dataset.variantId),
          quantity: a.dataset.followQty === 'true' ? tierQty(radio) : 1
        });
      });

      return items;
    }

    function renderTiers() {
      bundles.forEach(function (r) {
        var box = r.nextElementSibling;
        if (!box) return;
        var cents = tierCents(r);
        var compare = tierCompareCents(r);
        var discounted = compare > cents;

        setText(box.querySelector('.bc-tier__price b'), money(cents));

        var s = box.querySelector('.bc-tier__price s');
        show(s, discounted);
        if (discounted) setText(s, money(compare));

        var save = box.querySelector('.bc-tier__save');
        show(save, discounted);
        if (discounted) setText(save, 'You save ' + money(compare - cents));
      });
    }

    function sync() {
      var radio = selected(bundles);
      if (!radio) return;

      renderTiers();

      var baseCents = tierCents(radio);
      var compareCents = tierCompareCents(radio);
      var discounted = compareCents > baseCents;

      /* keep the plain form POST usable if fetch ever fails */
      var picks = picksIn(tierOf(radio));
      if (idInput && picks.length && picks[0].value) idInput.value = picks[0].value;
      if (qtyInput) qtyInput.value = tierQty(radio);

      setText(priceEl, money(baseCents));
      show(wasEl, discounted);
      if (discounted) setText(wasEl, money(compareCents));
      show(offEl, discounted);
      if (discounted) {
        setText(offEl, Math.round((1 - baseCents / compareCents) * 100) + '% OFF');
      }

      var total = money(baseCents + addonCents());
      setText(atcEl, total);
      setText(stickyEl, total);

      var btn = document.getElementById('bcAtcBtn');
      if (btn) {
        var soldOut = picks.some(function (s) {
          var o = chosen(s);
          return o && o.dataset.available === 'false';
        });
        btn.disabled = soldOut;
        if (soldOut) {
          btn.textContent = 'Sold out';
          atcEl = null;
        } else {
          btn.innerHTML = (btn.dataset.label || 'Add to cart') +
            ' &mdash; <span id="bcAtcPrice">' + total + '</span>';
          atcEl = document.getElementById('bcAtcPrice');
        }
      }
    }

    /* every tier carries the same bump list - keep the choice when the
       customer switches bundle instead of resetting it */
    addons.forEach(function (a) {
      a.addEventListener('change', function () {
        var key = a.dataset.addon;
        if (key) {
          addons.forEach(function (other) {
            if (other !== a && other.dataset.addon === key) other.checked = a.checked;
          });
        }
        sync();
      });
    });

    bundles.forEach(function (r) { r.addEventListener('change', sync); });

    tiersWrap.addEventListener('change', function (e) {
      if (e.target.matches('select[data-pick]')) sync();
    });

    sync();


    /* ---------- 3b. send every picked colour as its own cart line ------ */
    var productForm = document.getElementById('bcForm');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        var items = cartItems();
        if (!items.length) return;

        e.preventDefault();
        var btn = document.getElementById('bcAtcBtn');
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add failed');
            window.location.href = (window.BrewClick && window.BrewClick.cartUrl) || '/cart';
          })
          .catch(function () {
            /* fall back to the normal POST so the customer is never stuck */
            if (btn) btn.disabled = false;
            productForm.submit();
          });
      });
    }


    /* ---------- 4. estimated delivery date ---------------------------- */
    var eta = document.getElementById('bcEta');
    if (eta) {
      var days = parseInt(eta.dataset.days || '9', 10);
      var d = new Date();
      d.setDate(d.getDate() + days);
      eta.textContent = d.toLocaleDateString(
        document.documentElement.lang || 'en-GB',
        { day: 'numeric', month: 'long' }
      );
    }

    var year = document.getElementById('bcYear');
    if (year) year.textContent = new Date().getFullYear();

    /* ---------- 5. sticky add-to-cart bar ------------------------------ */
    var bar = document.getElementById('bcSticky');
    var anchor = document.querySelector('.bc-atcwrap');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    var stickyBtn = document.getElementById('bcStickyBtn');
    if (stickyBtn && productForm) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        productForm.requestSubmit ? productForm.requestSubmit() : productForm.submit();
      });
    }
  });
})();
